import api from "../utils/API";

// Base URL for your API
export const paymentsService = {
  fetchList: async (payload) => {
    try {
      const response = await api.get("/admin/payment", { params: payload });
      return response?.data;
    } catch (error) {
      return error.response.data;
    }
  },

  previewPayments: async (payload) => {
    try {
      const response = await api.post("/admin/payment/preview-upload", payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },

  syncPayments: async (payload) => {
    try {
      const response = await api.post("/admin/payment", payload);
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
};
